import { gql } from '@apollo/client';

// Define the GraphQL query
export const EXPLORE_PROPERTY_BUTTON = gql`
  query landingpageExploreButton(
      $companyId: String!,
      $countryId: String!
      ){
      landingpageExploreButton(
      companyId: $companyId,
      countryId: $countryId
      ){
        id
        foreignBillboardId
        name
        displayName
        deviceId
        latitude
        longitude
        category
        type
        resolutionWidth
        resolutionHeight
        panelWidth
        panelHeight
        panelSize
        venueType
        facingDirection
        format
        group
        formattedAddress
        spotsPerHour
        mediaOwnerId
        mediaOwnerName
        publisherDomain
        countryId
        countryName
        countryIso2
        stateId
        stateName
        districtId
        districtName
        timezone
        active
        availableBooking
        subscription
        thumbnailPath
        fullResImagePath
        googleMapUrl
        programmaticEnabled
        loopDuration
        spotDuration
        clients
        displayOnTime
        displayOffTime
        totalSpots
        totalBookedSpots
        spotsAvailability
        clientsAvailability
        nextAvailableDate
        spotAvailabilityPerc
        sellingRate {
          dsp
          standard
          daily
          weekly
          spots
          monthly {
            month3
            month6
            month1
            month12
          }
         
        }
        freqModel {
          id
          coef
          intercept
        }
        monthlySummary {
          id
          childPercentage
          childVisitors
          adultPercentage
          adultVisitors
          youngAdultPercentage
          youngAdultVisitors
          femalePercentage
          femaleVisitors
          malePercentage
          maleVisitors
          seniorPercentage
          seniorVisitors
          totalVisitors
          uniqueVisitors
          reach
          frequency
          circulation
        }
        createdBy
        createdDate
        lastModifiedBy
        lastModifiedDate
        count
        specification {
          id
          specificationId
          description
          panel
          screens
          manufacturer
          playerSoftware
          playerSoftwareModule {
            id
            name
            shortName
            description
            apiUrl
            accessToken
            active
            integratedWithLmx
            allowedPushToContentTypes
            creativeConfiguration
          }
          otherPlayer
          resolution1Width
          resolution1Height
          panel1Width
          panel1Height
          panel1Size
          resolution2Width
          resolution2Height
          panel2Width
          panel2Height
          panel2Size
          resolution3Width
          resolution3Height
          panel3Width
          panel3Height
          panel3Size
          resolution4Width
          resolution4Height
          panel4Width
          panel4Height
          panel4Size
          resolution5Width
          resolution5Height
          panel5Width
          panel5Height
          panel5Size
          resolution6Width
          resolution6Height
          panel6Width
          panel6Height
          panel6Size
          age
          totalSquareResolution
          ledPitch
          videoSupport
          imageSupport
          audioSupport
          audioFormats
          contentApproval
          featureSupport
          availableHours
          leadTime
          exclusiveTo
          language
          creativeResolutionWidth
          creativeResolutionHeight
          sellAsNetwork
          roadSideBoard
          heightFromFloor
          billboardSize
          supportedMediaType
          motionAndStatic
          panel1Id
          panel2Id
          panel3Id
          panel4Id
          panel5Id
          panel6Id
          frameId
          panelSizeList
        }
        price {
          id
          priceId
          screenOnTime
          screenOffTime
          displayOnTime
          displayOffTime
          spotDuration
          contentFrequencyPerHour
          clients
          localCurrencies {
            id
            currencyId
            iso
            country
            currency
            code
            symbol
            numcode
            decimals
            locale
          }
          localStandardRates
          internationalStandardRates
          buyingLocalMonthlyRates
          buyingInternationalMonthlyRates
          sellingLocalMonthlyRates
          sellingInternationalMonthlyRates
          fullDay
          daypart
          daypartEntries
          minimumSpotDurationPerDay
          maximumSpotDurationPerDay
          localContentManagementCost
          internationalContentManagementCost
          modeOfOperation
          loopDurationInSeconds
          loopLocalBuyingRates
          loopLocalSellingRates
          loopInternationalBuyingRates
          loopInternationalSellingRates
          spotLocalBaseRates
          spotInternationalBaseRates
          spotMediaOperatorPercentage
          spotInternalPercentage
          screenDuration
          loopDuration
          movingWallsSpot
          nearbyPOI
          viewability
          programmaticEnabled
          availableForBuying
          customizeSellingTerms
          digitalBillboardDayMinimumValue
          enableDigitalDay
          digitalBillboardHourMinimumValue
          enableDigitalHour
          sellingTermsPrice
          rateCardType
          reason
          spotMapping
          apiIntegration
          htmlPlayable
          spotBasedPrice
          floorPrice
          creativeType
          openAuctionType
          openAuctionMinimumSpots
          openAuctionMinimumPercentage
          openAuctionCurrency
          openAuctionSpotDuration
          auctionType
          impMultiplier
          fillerContentUrl
          creativeServerUrl
          manufacturingCost
          constructionCost
          maintenanceCost
          otherCosts
          availableHoursStart
          availableHoursEnd
          offlinePath
          spotAllocations
          totalSquareResolution
          spotAllocationArr
          availabilityPerc
          spotsAvailability
          clientsAvailability
          nextAvailableDate
          spotAvailabilityPerc
        }
        trTimeZone
        trCountryName
        trStateName
        trDistrictName
        tags {
          id
          companyId
          companyName
          name
          swatches
          integrations
        }
        filteringFields
      }
    }

`;

// export const PROPERTY_LIST = gql`
//   query LandingpageExploreProperties(
//       $accessToken: String!,
//       $sort: String!,
//       $billboard: String!
//       $startDate: String!,
//       $endDate: String!,
//       $dspName: String!,
//       $companyId: String!,
//       $countryId: String!,
//       $page: Int!,
//       $size: Int!
//     ){
//     landingpageExploreProperties(
//       accessToken: $accessToken,
//       sort: $sort,
//       billboard: $billboard,
//       startDate: $startDate,
//       endDate: $endDate,
//       dspName: $dspName,
//       companyId: $companyId,
//       countryId: $countryId,
//       page: $page,
//       size: $size
//     ) {
//       id
//       name
//       displayName
//       referenceId
//       latitude
//       longitude
//       category
//       type
//       panelWidth
//       panelHeight
//       resolutionWidth
//       resolutionHeight
//       panelSize
//       formattedAddress
//       facingDirection
//       group
//       venueType
//       mediaOwnerId
//       specification {
//         screens
//       }
//       price{
//         staticBillboardDayMinimumValue
//       }
//       mediaOwnerName
//       countryId
//       countryName
//       stateId
//       stateName
//       districtId
//       districtName
//       active
//       availableBooking
//       subscription
//       thumbnailPath
//       fullResImagePath
//       googleMapUrl
//       timezone
//       totalSpots
//       totalBookedSpots
//       spotsAvailability
//       spotAvailabilityPerc
//       clientsAvailability
//       nextAvailableDate
//       createdBy
//       createdDate
//       lastModifiedBy
//       lastModifiedDate
//       count
//       trTimeZone
//       trCountryName
//       trStateName
//       trDistrictName
//       sellingRate {
//         dsp
//         daily
//         weekly
//         spots
//         monthly {
//           month1
//         }
//       }
//       monthlySummary {
//         id
//         childPercentage
//         uniqueVisitors
//         totalVisitors
//       }
//     }
//   }
// `;
//PropertyList VenueType
export const PROPERTY_LIST_VENUE_TYPE_LIST = gql`
  query GetVenueTypeList {
    venueTypes {
      id
      name
      value
      child {
        id
        name
        value
        child {
          id
          name
          value
        }
      }
    }
  }
`;
// Register

export const REGISTER_MUTATION = gql`
  mutation RegisterUser($input: RegisterUserPayload!) {
    createUserOtp(input: $input) {
      success
      message
      id
      email
      companyId
    }
  }
`;

export const COUPONS_MUTATION = gql`
  mutation ValidateCoupon($couponCode: String!) {
    validateCoupon(couponCode: $couponCode) {
      couponData {
        success
        message
        statusCode
        discount
      }
    }
  }
`;

// State List Dropdown 

export const GET_STATE_LIST = gql`
  query GetStateList($countryId: String!) {
    stateList(countryId: $countryId) {
      stateId
      name
    }
  }
`;

export const Get_Currency_Code_Details = gql`

    query GetCurrencyCodeDetails($countryCurrencyCode: String!) {
      currencyCodeDetails(countryCurrencyCode: $countryCurrencyCode) {
        country
        currencyCode
      }
    }
  `;

export const Media_Id = gql`
  mutation GetMediaOwnerByDomain($domainName: String!) {
    mediaOwnerByDomain(input: { domainName: $domainName }) {
      mediaOwner {
        id
        domainName
        mediaOwnerCompanyId
      }
    }
  }
`;

export const Get_Country_Code = gql`
  query GetCountryCodeExplore($ownerId: String!) {
    getCountryCodeNoToken(ownerId: $ownerId) {
      countryId
      countryName
      tax {
        label
        percent
      }
    }
  }
`;

// Explore_Property VenueType

export const EXPLORE_PROPERTY_VENUE_TYPE_LIST = gql`
  query GetVenueTypeList($countryId: String!) {
    venueTypes(countryId: $countryId) {
      id
      name
      value
      child {
        id
        name
        value
        child {
          id
          name
          value
        }
      }
    }
  }
`;

export const PROPERTY_DETAILS = gql`
  query PropertyDetails(
    $companyId: String
    $countryId: String
    $id: String!
    $billboardType: String!
    $startDate: String
    $endDate: String
    $accessToken: String
  ) {
    propertyDetails(
      accessToken: $accessToken
      companyId: $companyId
      countryId: $countryId
      id: $id
      billboardType: $billboardType
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      referenceId
      deviceId
      name
      displayName
      company
      facingDirection
      cardinalPoint
      category
      subCategory
      type
      format
      latitude
      longitude
      venueType
      formattedAddress
      availableBooking
      active
      totalVisitors
      spotsPerHour
      mediaOwnerName
      nextAvailableDate
      impressionPerDay
      impressionPerSpot 
      perDayPrice
      perSpotPrice
      specification {
        leadTime
        panel
        screens
        playerSoftwareModule {
          id
          name
          shortName
          description
          apiUrl
          accessToken
          active
          integratedWithLmx
          allowedPushToContentTypes
          creativeConfiguration
          resolutionMode
        }
        exclusionCategory {
          id
          iabCode
          value
          children {
            id
            iabCode
            value
            children {
              id
              iabCode
              value
              trValue
            }
            trValue
          }
          trValue
        }
        resolution1Width
        resolution1Height
        faces
        unit
        panelWidth
        panelHeight
        panel1Width
        panel1Height
        panel1Size
        sellAsNetwork
        videoSupport
        imageSupport
        audioSupport
        audioFormats
        contentApproval
        featureSupport
        availableHours
        leadTime
        heightFromFloor
        billboardSize
      }
      price {
        screenOnTime
        screenOffTime
        displayOnTime
        displayOffTime
        spotDuration
        contentFrequencyPerHour
        clients
        localCurrencies {
          id
          currencyId
          iso
          country
          currency
          code
          symbol
          numcode
          decimals
          locale
        }
        availableDays
        minimumSpotDurationPerDay
        maximumSpotDurationPerDay
        modeOfOperation
        loopDuration
        programmaticEnabled
        exposeToBuyer
        dealType
        openAuctionType
        openAuctionCurrency
        openAuctionSpotDuration
      }
      thumbnailPath
      timezone
      companyId {
        id
        companyId
        name
        companyType
        registrationNumber
        registrationAddress {
          street
          city
          state
          country
          postCode
          building
          trCountryName
          trStateName
          trDistrictName
          concatenatedAddress
        }
      }
      trTimeZone
      trFormat
      createdDate
      lastModifiedBy
      lastModifiedDate
      totalBillboardCount
      summaryMonth
      country {
        id
        name
        nameJa
        latitude
        longitude
        zoom
        swLat
        swLng
        seLat
        seLng
        neLat
        neLng
        nwLat
        nwLng
        population
        iso
        locale
        countryId
        active
        trCountryName
        tax {
          label
          percent
        }
      }
      state {
        id
        name
        nameJa
        stateId
        type
        latitude
        longitude
        zoom
        swLat
        swLng
        seLat
        seLng
        neLat
        neLng
        nwLat
        nwLng
        population
        iso
        locale
        trStateName
        country {
          id
          countryId
          name
          trCountryName
        }
      }
      district {
        id
        name
        nameJa
        districtId
        type
        latitude
        longitude
        zoom
        swLat
        swLng
        seLat
        seLng
        neLat
        neLng
        nwLat
        nwLng
        population
        locale
        trDistrictName
        state {
          id
          stateId
          name
          trStateName
        }
      }
      sellingRate {
        dsp
        daily
        weekly
        monthly {
          month1
          month3
          month6
          month12
        } 
      }
      monthlySummary {
        id
        childPercentage
        childVisitors
        adultPercentage
        adultVisitors
        youngAdultPercentage
        youngAdultVisitors
        femalePercentage
        femaleVisitors
        malePercentage
        maleVisitors
        seniorPercentage
        seniorVisitors
        totalVisitors
        uniqueVisitors
        reach
        frequency
        circulation
      }
    }
  }
`


//Explore Property
export const GET_LANDING_EXPLORATION = gql`
  query LandingExploreProperties(
    $billboard: String!,
    $page: Int!,
    $size: Int!,
    $sort: String!,
    $startDate: String!,
    $endDate: String!,
    $dspName: String!,
    $companyId: String!,
    $countryId: String!,
    $searchTerm: String!,
    $filterData: FilterDataInput!
  ) {
    landingpageExplorePropertiesNotoken(
      billboard: $billboard,
      page: $page,
      size: $size,
      sort: $sort,
      startDate: $startDate,
      endDate: $endDate,
      dspName: $dspName,
      companyId: $companyId,
      countryId: $countryId,
      searchTerm: $searchTerm,
      filterData: $filterData
    ) {
      id
      name
      displayName
      referenceId
      latitude
      longitude
      category
      type
      panelWidth
      panelHeight
      resolutionWidth
      resolutionHeight
      panelSize
      formattedAddress
      facingDirection
      group
      venueType
      totalSize
      mediaOwnerId
      nextAvailableDate
      format
      specification {
        id
        specificationId
        description
        panel
        screens
        manufacturer
        playerSoftware
        playerSoftwareModule {
          id
          name
          shortName
          description
          apiUrl
          accessToken
          active
          integratedWithLmx
          allowedPushToContentTypes
          creativeConfiguration
        }
        otherPlayer
        resolution1Width
        resolution1Height
        panel1Width
        panel1Height
        panel1Size
        resolution2Width
        resolution2Height
        panel2Width
        panel2Height
        panel2Size
        resolution3Width
        resolution3Height
        panel3Width
        panel3Height
        panel3Size
        resolution4Width
        resolution4Height
        panel4Width
        panel4Height
        panel4Size
        resolution5Width
        resolution5Height
        panel5Width
        panel5Height
        panel5Size
        resolution6Width
        resolution6Height
        panel6Width
        panel6Height
        panel6Size
        age
        totalSquareResolution
        ledPitch
        videoSupport
        imageSupport
        audioSupport
        audioFormats
        contentApproval
        featureSupport
        availableHours
        leadTime
        exclusiveTo
        language
        creativeResolutionWidth
        creativeResolutionHeight
        sellAsNetwork
        roadSideBoard
        heightFromFloor
        billboardSize
        supportedMediaType
        motionAndStatic
        panel1Id
        panel2Id
        panel3Id
        panel4Id
        panel5Id
        panel6Id
        frameId
        panelSizeList
      }
      price {
        id
        priceId
        screenOnTime
        screenOffTime
        displayOnTime
        displayOffTime
        spotDuration
        contentFrequencyPerHour
        clients
        localCurrencies {
          id
          currencyId
          iso
          country
          currency
          code
          symbol
          numcode
          decimals
          locale
        }
        localStandardRates
        internationalStandardRates
        buyingLocalMonthlyRates
        buyingInternationalMonthlyRates
        sellingLocalMonthlyRates
        sellingInternationalMonthlyRates
        fullDay
        daypart
        daypartEntries
        minimumSpotDurationPerDay
        maximumSpotDurationPerDay
        localContentManagementCost
        internationalContentManagementCost
        modeOfOperation
        loopDurationInSeconds
        loopLocalBuyingRates
        loopLocalSellingRates
        loopInternationalBuyingRates
        loopInternationalSellingRates
        spotLocalBaseRates
        spotInternationalBaseRates
        spotMediaOperatorPercentage
        spotInternalPercentage
        screenDuration
        loopDuration
        movingWallsSpot
        nearbyPOI
        viewability
        programmaticEnabled
        availableForBuying
        customizeSellingTerms
        digitalBillboardDayMinimumValue
        enableDigitalDay
        digitalBillboardHourMinimumValue
        enableDigitalHour
        sellingTermsPrice
        rateCardType
        reason
        spotMapping
        apiIntegration
        htmlPlayable
        spotBasedPrice
        floorPrice
        creativeType
        openAuctionType
        openAuctionMinimumSpots
        openAuctionMinimumPercentage
        openAuctionCurrency
        openAuctionSpotDuration
        auctionType
        impMultiplier
        fillerContentUrl
        creativeServerUrl
        manufacturingCost
        constructionCost
        maintenanceCost
        otherCosts
        availableHoursStart
        availableHoursEnd
        offlinePath
        spotAllocations
        totalSquareResolution
        spotAllocationArr
        availabilityPerc
        spotsAvailability
        clientsAvailability
        nextAvailableDate
        spotAvailabilityPerc
      }
      mediaOwnerName
      countryId
      countryName
      stateId
      stateName
      districtId
      districtName
      active
      availableBooking
      subscription
      thumbnailPath
      fullResImagePath
      googleMapUrl
      timezone
      totalSpots
      totalBookedSpots
      spotsAvailability
      spotAvailabilityPerc
      clientsAvailability
      nextAvailableDate
      currency
      createdBy
      createdDate
      lastModifiedBy
      lastModifiedDate
      count
      trTimeZone
      trCountryName
      trStateName
      trDistrictName
      sellingRate {
        dsp
        daily
        weekly
        spots
        monthly {
          month1
          month3
          month6
          month12
        }
      }
      monthlySummary {
        id
        childPercentage
        childVisitors
        adultPercentage
        adultVisitors
        youngAdultPercentage
        youngAdultVisitors
        femalePercentage
        femaleVisitors
        malePercentage
        maleVisitors
        seniorPercentage
        seniorVisitors
        totalVisitors
        uniqueVisitors
        reach
        frequency
        circulation
      }
    }
  }
`;


export const GET_COUNTRY_LIST = gql`
  query {
      countryList {
        countryId
        name
        iso
        dialingCode
        id
        currencyCode
        region
        tax {
          label
          percent
        }
      }
    }

`;

export const GET_MARKETPLACE_COUNTRIES = gql`
  query getMarketplaceCountries($exposure: String!) {
      getMarketplaceCountries(exposure: $exposure) {
        countryId
        name
        iso
        dialingCode
        id
        currencyCode
        region
        tax {
          label
          percent
        }
      }
    }
`;
export const GET_COUNTRY_BY_IP = gql`
  query getCountryByIp($ipAddress: String!) {
    getCountryByIp(ipAddress: $ipAddress) {
      ipAddress
      country
      success
      message
    }
  }
`;

// Home3_billboard
export const Get_ThreeBillboard = gql`
  query topThreeBillboard($companyId: String, $size: Int!, $dsp: String!, $countryId: String, $isCurated: Boolean) {
    topThreeBillboard(companyId: $companyId, size: $size, dsp: $dsp, countryId: $countryId, isCurated: $isCurated) {
      id
      stateId
      stateName
      displayName
      priceRates
      thumbnailPath
      billboardType
      billboardObjectId
      weeklyPrice
      totalVisitors
      totalViews
      currentPrice 
      perDayPrice 
      perSpotPrice
      currencyCode
    }
  }
`;


export const AUTHENTICATE_MUTATION = gql`
    mutation Authenticate($username: String!, $password: String!) {
        authenticate(input: { username: $username, password: $password }) {
            authData {
                accessToken
                expiresIn
                scope
                tokenType
            }
        }   
    }
`;


// Forgot Query

export const FORGET_PASSWORD = gql`
  mutation forgetPassword($email: String!, $platformSource: String!, $platformBaseUrl: String!, $publisherId: String!, $baseUrl: String) {
    forgetPassword(email: $email, platformSource: $platformSource, platformBaseUrl: $platformBaseUrl, publisherId: $publisherId, baseUrl: $baseUrl) {
      message
    }
  }
`;



export const MYCAMPAIGN_LIST = gql`
    query mycampaignList($accessToken: String!,
    $page: Int!,
    $size: Int!,
    $sort: String!,
    $companyId: String!,
    $campaignStatus: String,
    $userId: String!,
    $name: String!
    ) {
        mycampaignList(accessToken: $accessToken,
        page: $page,
        size:$size,
        sort:  $sort,
        companyId: $companyId,
        campaignStatus: $campaignStatus,
        userId: $userId,
        name: $name
        ) {
            content {
                id
                dealId
                name
                bookingSource
                startDate {
                  date
                  dateStr
                  dateFmt
                }
                endDate {
                  date
                  dateStr
                  dateFmt
                }
                dsp
                campaignStatus
                priceSummary {
                  subTotal
                  netTotal
                  currency {
                    country
                    symbol
                    code
                  }
                  tax {
                    name
                    value
                    percent
                  }
                  couponName
                  discountPercent
                  discountedPrice
                  pcrEnable
                }
                inventoriesSummary {
                  classicInventories
                  digitalInventories
                  packages
                }
                packages
                campaignInventories {
                  id
                  dsp
                  startDate
                  endDate
                  companyId
                  inventoryName
                  inventoryId
                  inventoryReferenceId
                  deviceId
                  foreignBillboardId
                  networkId
                  inventoryType
                  inventoryAddress
                  inventoryVenueType
                  inventoryResolutions
                  inventoryThumbnailUrl
                  packageDetails
                  inventoryPrice
                  inventoryReports {
                    totalPotentialViews
                    averageFrequency
                    cpm
                    totalReach
                  }
                  inventoryLatitude
                  inventoryLongitude
                  inventoryFormat
                  nowPayPrice
                  discount
                  spotDuration
                  negotiationSummary
                }
                agency {
                  id
                  name
                }
                company {
                  id
                  name
                }
                user {
                  id
                  name
                }
                summaryReport {
                  potentialViews
                  uniqueReach
                  cpm
                  averageFrequency
                  totalSpots
                }
                externalCampaignId
                madCampaignId
                reasonForRejection
                reporting
                negotiationSummary
                mediaBookingOrdersInvoiceId
            }
            pageable {
                sort {
                    sorted
                    unsorted
                }
                offset
                pageSize
                pageNumber
                unpaged
                paged
            }
            last
            totalElements
            totalPages
            size
            number
            first
            sort {
                sorted
                unsorted
            }
            numberOfElements
        }
    }
`


export const GET_CAMPAIGNS = gql`
query getCampaigns($campaignId: String!){
  getCampaigns(campaignId: $campaignId) {
    id
    campaignName
    startDate
    endDate
    state
    district
    createdAt
  }
}
`
export const GET_DISTRICT_LIST = gql`
  query GetDistrictList($stateid: String!) {
    districtList(stateid: $stateid) {
      id
      districtId
      name
      __typename
    }
  }
`;
export const CART_PAGE_ITEM = gql`
  query cartPageItem($accessToken: String!, $userId: String!, $edit: Boolean!, $campaignId: String!, $startDate: String!, $endDate: String!, $billboardSpots: [CartSpotDataInput!], $exposure: String!, $discount: Float) {
    cartPageItem(
      accessToken: $accessToken,
      userId: $userId,
      edit: $edit,
      campaignId: $campaignId,
      startDate: $startDate,
      endDate: $endDate,
      billboardSpots: $billboardSpots,
      exposure: $exposure,
      discount: $discount
    ) {
        id
        userId
        agencyId
        agencyName
        companyId
        companyName
        countryId
        countryName
        taxLabel
        taxPercent
        campaignName
        startDate
        endDate
        discountPercent
        discountAmount
        overAlltotalBeforeDiscount
        inventoriesSummary{
          classicInventories 
          digitalInventories
          packages
        }
        overAlltotalNet
        overAlltotalTax
        overAlltotalPrice
        overAlltotalUniqueReach
        overAlltotalPotentialViews
        overAlltotalAverageFrequency
        couponName
        totalDuration
        campaignInventories{
          billboardPotentialViews
          cartItemId
          billboardId
          billboardName
          billboardType
          billboardAddress
          billboardCountry
          billboardDeviceId
          billboardReferenceId
          billboardLatitude
          billboardVenueType
          billboardFrequency
          billboardLongitude
          billboardUniqueReach
          billboardResolutionWidth
          billboardResolutionHeight
          billboardPeriodSubTotalPrice
          billboardThumbnailUrl
          billboardCurrencyCode
          isDraft
          availableBooking
          mediaOwnerId
          mediaOwnerName
          minimumSellingDays
          minimumSellingHour
          minimumSpotsPerDay
          validityStartDate
          validityEndDate
          campaignDuration
          maximumSpotDurationPerDay
          customizeSellingTerms
          userSelectedSpots
          isSpotBased
          spotPrice
          spotDuration
          singleSpotCost
          currencyCode
          isSpotBased
          leadTime
        }
      }
  }
`;
export const DELETE_CART_PAGE = gql`
  mutation deleteCartItem($accessToken: String!, $deleteItems: [DeleteItemInput!]!) {
    deleteCartItem(accessToken: $accessToken, deleteItems: $deleteItems) {
      success
      message
      statusCode
      deletedItems
    }
  }
`;

export const REQUEST_FOR_APPROVAL = gql`
    mutation requestForApproval(  
        $campaignType: String!,
        $campaignId: String!,
        $input: CampaignInput!
    ) {
        requestForApproval(
            campaignType: $campaignType,
            campaignId: $campaignId,
            input: $input
        ) {
            campaign {
                id
                dealId
                name
                bookingSource
                startDate
                endDate
                campaignStatus
            }
        }
    }
`;


export const MY_CART_ITEM_LIST = gql`
  query mycartItemList($accessToken: String!, $id: String!) {
    mycartItemList(accessToken: $accessToken, id: $id) {
      id
      group
      resolutionWidth
      thumbnailPath
      fullResImagePath
      resolutionHeight
      name
      displayName
      type
      sellingRate {
        monthly {
          month1
        }
      }
      monthlySummary {
        id
        totalVisitors
        uniqueVisitors
        reach
        frequency
      }
    }
  }
`;

// Added for account detail on 25-07-2024 by tejashree

export const ACCOUNT = gql`
query($accessToken: String!) {
  userAccount(accessToken: $accessToken){
    id
    email
    companyId
    countryId
    username
    email
    companyName
    countryName
    taxPercent
    taxLabel   
    dsp
    latitude
    longitude
    firstName
    lastName
  }
}`

// Added for Content hub list  on 30-07-2024 by tejashree
// export const CONTENTHUB = gql`
//   query ContentHub(
//     $accessToken: String!,
//     $page: Int!,
//     $size: Int!, 
//     $metadatatype:String!,
//     $metadatacampaign: Boolean!,
//     $companyId: String!,
//     $creatives: Boolean!,
//     $userId: String!,
//     $sort: String!
//     ){
//     contentHub(
//       accessToken: $accessToken,
//       page: $page,
//       size:$size, 
//       metadatatype:$metadatatype,
//       metadatacampaign: $metadatacampaign,
//       companyId: $companyId,
//       creatives: $creatives,
//       userId: $userId,
//       sort: $sort
//     ){
//       id
//       fileName
//       mimeType
//       filePath
//       duration
//       userId
//       companyId
//       countryId
//       status
//       resolution
//       userCountry
//     }
//   }`



// Query for Property details added by Tejashree on 13-08-2024

export const GET_PROPERTY_DETAILS = gql`
  query GetPropertyDetails(
    $accessToken: String!, 
    $id: String!, 
    $countryId: String!, 
    $companyId: String!, 
    $billboardType: String!
  ) {
    propertyDetails(
      accessToken: $accessToken, 
      id: $id, 
      countryId: $countryId, 
      companyId: $companyId, 
      billboardType: $billboardType
    ) {
      referenceId
      latitude
      longitude
      deviceId
      name
      displayName
      company
      facingDirection
      cardinalPoint
      category
      subCategory
      group
      type
      stateName
      format
      venueType
      mediaOwnerName
      loopDuration
      displayOnTime
      displayOffTime
      nextAvailableDate
      sellingRate {
        dsp
        daily
        weekly
        spots
        monthly {
          month1
          month3
          month6
          month12
        }
      }
      venueTypeItems {
        parents
        childs
        grandChilds
      }
      venueTypeLocale {
        en
      }
      district {
        id
        districtId
        name
        nameJa
        type
        state {
          id
          stateId
          name
          nameJa
          type
          country {
            id
            countryId
            name
            nameJa
            latitude
            longitude
            zoom
            mediaOwnerTermsAndConditions
            buyerTermsAndConditions
            population
            iso
            postalformat
            postalname
            geopc
            active
            dialingCode
            timezone
            miDataSensorStatus
            tax {
              label
              percent
            }
          }
        }
        trDistrictName
        miDataSensorStatus
      }
      formattedAddress
      specification {
        panel
        screens
        resolution1Width
        resolution1Height
        panel1Size
        playerSoftwareModule {
          id
          description
          apiUrl
          accessToken
          active
          integratedWithLmx
          allowedPushToContentTypes
          creativeConfiguration
        }
        ledPitch
        videoSupport
        imageSupport
        audioSupport
        audioFormats
        contentApproval
        featureSupport
        availableHours
        billboardSize
        panels
      }
      monthlySummary {
        id
        totalVisitors
        uniqueVisitors
        reach
        frequency
        circulation
        childPercentage
        childVisitors
        adultPercentage
        adultVisitors
        youngAdultPercentage
        youngAdultVisitors
        femalePercentage
        femaleVisitors
        malePercentage
        maleVisitors
        seniorPercentage
        seniorVisitors
      }
      price {
        screenOnTime
        screenOffTime
        openAuctionCurrency
        spotDuration
        contentFrequencyPerHour
        clients
        modeOfOperation
        maximumSpotDurationPerDay
        minimumSpotDurationPerDay
        
      }
      thumbnailPath
      companyId {
        id
        companyId
        name
        companyType
        registrationNumber
        registrationAddress {
          street
          city
          state
          country
          district
          postCode
          building
          trCountryName
          trStateName
          trDistrictName
          concatenatedAddress
        }
      }
      phone
      timezone
      dataSource
      supportedMediaType
    }
  }
`


//Landing-Contact-us
export const CONTACT_US_MUTATION = gql`
  mutation ContactUs(
    $body: JSONString!
    $toAddress: [String!]!
    $template: String
    $mailConfig: MailConfigInput
  ) {
    contactUs(
      body: $body
      toAddress: $toAddress
      template: $template
      mailConfig: $mailConfig
    ) {
      status
    }
  }
`;

// Delivery-Report

export const DELIVERY_REPORTS_QUERY = gql`
    query DeliveryReports(
        $accessToken: String!,
        $campaignId: String!,
        $page: Int,
        $size: Int,
        $sort: String,
        $search: String
    ) {
        deliveryReports(
            accessToken: $accessToken,
            campaignId: $campaignId,
            page: $page,
            size: $size,
            sort: $sort,
            search: $search
        ) {
            id
            campaignName
            campaignId
            campaignStatus
            dealId
            dsp
            agency {
                id
                name
            }
            startDate {
                date
                dateStr
                dateFmt
            }
            endDate {
                date
                dateStr
                dateFmt
            }
            totalPages
            companyId
            inventoryName
            inventoryId
            inventoryReferenceId
            deviceId
            inventoryType
            inventoryAddress
            inventoryVenueType
            inventoryResolutions
            inventoryLocation
            inventoryReports {
                totalPotentialViews
                averageFrequency
                cpm
                totalReach
            }
            inventoryThumbnailUrl
            inventoryLatitude
            inventoryLongitude
            inventoryPrice
            availableBooking
            nextAvailableDate
            spotsAvailability
            clientsAvailability
            isSpotBased
            inventoryDetails {
                id
                billboardId
                referenceId
                deviceId
                name
                displayName
                company
                facingDirection
                category
                group
                type
                format
                venueType
                latitude
                longitude
                active
                mediaOwnerName
                mediaOwnerId
                country {
                    id
                    countryId
                    name
                    latitude
                    longitude
                    population
                    iso
                    postalformat
                    postalname
                    geopc
                    active
                    dialingCode
                    timezone
                    miDataSensorStatus
                    tax {
                        label
                        percent
                    }
                }
                city
                companyId {
                    id
                    companyId
                    name
                    companyType
                    registrationNumber
                }
            }
        }
    }
`;

//Content-Hub

export const CONTENT_HUB_QUERY = gql`
  query ContentHub(
    $accessToken: String!,
    $page: Int!,
    $size: Int!,
    $metadatatype: String!,
    $metadatacampaign: Boolean!,
    $companyId: String!,
    $creatives: Boolean!,
    $userId: String!,
    $sort: String!,
    $fileName: String!,
    $resolution: String!,
    $mimeType: String!,
  ) {
    contentHub(
      accessToken: $accessToken,
      page: $page,
      size: $size,
      metadatatype: $metadatatype,
      metadatacampaign: $metadatacampaign,
      companyId: $companyId,
      creatives: $creatives,
      userId: $userId,
      sort: $sort,
      fileName: $fileName,
      resolution: $resolution,
      mimeType: $mimeType
    ) {
      id
      fileName
      mimeType
      duration
      filePath
      userId
      companyId
      countryId
      status
      resolution
      userCountry
      thumbnail
      totalPages
      contentSize
    }
  }
`;
export const UPLOAD_CONTENT_MUTATION = gql`
mutation UploadContent($accessToken: String!, $file: Upload!, $mediaOwnerId: String!, $filetype: String!, $source: String!, $userId: String!) {
          uploadcontent(
            accessToken: $accessToken,
            file: $file,
            mediaOwnerId: $mediaOwnerId,
            filetype: $filetype,
            source: $source,
            userId: $userId
          ) {
            success
            message
          }
        }
`;

export const DELETE_CONTENT_MUTATION = gql`
  mutation DeleteContent($accessToken: String!, $contentIds: [ID!]!) {
    deleteContent(accessToken: $accessToken, contentIds: $contentIds) {
      message
    }
  }
`;



export const MY_CAMPAIGN_LIST_QUERY = gql`
  query MyCampaignList(
    $accessToken: String!,
    $userId: String!,
    $companyId: String!,
    $sort: String!,
    $name: String!,
    $campaignStatus: String,
    $page: Int!,
    $size: Int!
  ) {
    mycampaignList(
      accessToken: $accessToken,
      userId: $userId,
      companyId: $companyId,
      sort: $sort,
      name: $name,
      campaignStatus: $campaignStatus,
      page: $page,
      size: $size
    ) {
      content {
        id
        dealId
        name
        bookingSource
        paymentType
        startDate {
          date
          dateStr
          dateFmt
        }
        endDate {
          date
          dateStr
          dateFmt
        }
        dsp
        campaignStatus
        priceSummary {
          subTotal
          netTotal
          currency {
            country
            symbol
            code
          }
          tax {
            name
            value
            percent
          }
          pcrEnable
          couponName
          discountPercent
          discountedPrice
        }
        inventoriesSummary {
          classicInventories
          digitalInventories
          packages
        }
        reporting {
        proofOfPlay
        deliveryReports
        }
        packages
        campaignInventories {
          id
          dsp
          startDate
          endDate
          companyId
          inventoryName
          inventoryId
          inventoryReferenceId
          deviceId
          foreignBillboardId
          networkId
          inventoryType
          inventoryAddress
          inventoryVenueType
          inventoryResolutions
          inventoryThumbnailUrl
          packageDetails
          inventoryPrice
          inventoryReports {
            totalPotentialViews
            averageFrequency
            cpm
            totalReach
          }
          inventoryLatitude
          inventoryLongitude
          inventoryFormat
          nowPayPrice
          discount
          spotDuration
          mediaOwnerId
          mediaOwnerName
          isSpotBased
          spotsPerDay
          negotiationSummary {
            buyerPreferredPrice {
              totalPrice
              savingsPrice
              savingsPerc
              nowPayPrice
              dailyPrice
              subTotal
            }
            mediaOwnerPreferredPrice {
              totalPrice
              savingsPrice
              savingsPerc
              nowPayPrice
              dailyPrice
              subTotal
            }
            contentManagementFeePerc
            platformFeePerc
            taxPerc
            discountPerc
            status
            accountType
            summaryReport {
              potentialViews
              uniqueReach
              cpm
              averageFrequency
              totalSpots
            }
          }
        }
        agency {
          id
          name
        }
        company {
          id
          name
        }
        user {
          id
          name
        }
        summaryReport {
          potentialViews
          uniqueReach
          cpm
          averageFrequency
          totalSpots
        }
        externalCampaignId
        madCampaignId
        reasonForRejection
        mediaBookingOrdersInvoiceId
        negotiationSummary {
          buyerPreferredPrice {
            totalPrice
            savingsPrice
            savingsPerc
            nowPayPrice
            dailyPrice
            subTotal
          }
          mediaOwnerPreferredPrice {
            totalPrice
            savingsPrice
            savingsPerc
            nowPayPrice
            dailyPrice
            subTotal
          }
          contentManagementFeePerc
          platformFeePerc
          taxPerc
          discountPerc
          status
          accountType
          summaryReport {
            potentialViews
            uniqueReach
            cpm
            averageFrequency
            totalSpots
          }
        }
      }
      pageable {
        sort {
          sorted
          unsorted
        }
        offset
        pageSize
        pageNumber
        unpaged
        paged
      }
      last
      totalElements
      totalPages
      size
      number
      first
      sort {
        sorted
        unsorted
      }
      numberOfElements
    }
  }
`;


export const INVOICE = gql`
  query Invoice($accessToken: String!, $campId: String!) {
    paymentInvoice(
      accessToken: $accessToken
      campID: $campId
    ) 
     {
        id
        dealId
        name
        bookingSource
        startDate {
          date
          dateStr
          dateFmt
        }
        endDate {
          date
          dateStr
          dateFmt
        }
        dsp
        campaignStatus
        paymentType
        priceSummary {
          grossTotal
          subTotal
          netTotal
          currency {
            country
            symbol
            code
          }
          tax {
            name
            value
            percent
          }
          pcrEnable
          couponName
          discountPercent
          discountedPrice
        }
        inventoriesSummary {
          classicInventories
          digitalInventories
          packages
        }
        packages
        campaignInventories {
          id
          dsp
          startDate
          endDate
          companyId
          inventoryName
          inventoryId
          inventoryReferenceId
          deviceId
          foreignBillboardId
          networkId
          inventoryType
          inventoryAddress
          inventoryVenueType
          inventoryResolutions
          inventoryThumbnailUrl
          packageDetails
          inventoryPrice
          mediaOwnerId
          mediaOwnerName
          isSpotBased
          inventoryReports {
            totalPotentialViews
            averageFrequency
            cpm
            totalReach
          }
          inventoryLatitude
          inventoryLongitude
          inventoryFormat
          nowPayPrice
          discount
          spotDuration
          spotsPerDay
          negotiationSummary {
            buyerPreferredPrice {
              totalPrice
              savingsPrice
              savingsPerc
              nowPayPrice
              dailyPrice
              subTotal
            }
            mediaOwnerPreferredPrice {
              totalPrice
              savingsPrice
              savingsPerc
              nowPayPrice
              dailyPrice
              subTotal
            }
            contentManagementFeePerc
            platformFeePerc
            taxPerc
            discountPerc
            customFees
            summaryReport {
              potentialViews
              uniqueReach
              cpm
              totalSpots
            }
            status
            accountType
            requestFrom
          }
        }
        agency {
          id
          name
        }
        company {
          id
          name
        }
        user {
          id
          name
        }
        summaryReport {
          potentialViews
          uniqueReach
          cpm
          averageFrequency
          totalSpots
        }
        externalCampaignId
        madCampaignId
        reasonForRejection
         reporting {
          proofOfPlay
          deliveryReports
        }
        negotiationSummary {
          buyerPreferredPrice {
            totalPrice
            savingsPrice
            savingsPerc
            nowPayPrice
            dailyPrice
            subTotal
          }
          mediaOwnerPreferredPrice {
            totalPrice
            savingsPrice
            savingsPerc
            nowPayPrice
            dailyPrice
            subTotal
          }
          contentManagementFeePerc
          platformFeePerc
          taxPerc
          discountPerc
          customFees
          summaryReport {
            potentialViews
            uniqueReach
            cpm
            totalSpots
          }
          status
          accountType
          requestFrom
        }
        mediaBookingOrdersInvoiceId {
          invoiceId
        }
      }

  }
`;

export const EDIT_CAMPAIGN = gql`
  query editCampaignList($accessToken: String!, $campaignId: String!, $userId : String!,$edit:Boolean!) {
      editPageItem(
      accessToken: $accessToken,
      edit: $edit,
      campaignId: $campaignId,
      userId: $userId
      ){
        userId
        agencyId
        agencyName
        companyId
        companyName
        countryId
        countryName
        	campaignName
        startDate
        endDate
	      inventoriesSummary{
          classicInventories 
          digitalInventories
          packages
        }
        overAlltotalNet
        overAlltotalTax
        overAlltotalPrice
        overAlltotalUniqueReach
        overAlltotalPotentialViews
        overAlltotalAverageFrequency
        campaignInventories{
          billboardPotentialViews
          cartItemId
          billboardId
          billboardName
          billboardType
          billboardAddress
          billboardCountry
          billboardDeviceId
          billboardReferenceId
          billboardLatitude
          billboardVenueType
          billboardFrequency
          billboardLongitude
          billboardUniqueReach
          billboardResolutionWidth
          billboardResolutionHeight
          billboardtotalPrice
          billboardPeriodSubTotalPrice
          billboardThumbnailUrl
          billboardFullResImageUrl
          billboardCurrencyCode
          availableBooking
          isDraft
        }
      }
  }
`;

// assign-creative list
export const ASSIGN_CREATIVES_ITEM_QUERY = gql`
query AssignCreativesItem($accessToken: String!, $id: String!, $searchTerm: String!, $page: String!) {
  assignCreativesItem(accessToken: $accessToken, id: $id, searchTerm: $searchTerm, page: $page) {
    id
    campaignName
    campaignId
    campaignStatus
    dealId
    dsp
    totalPages
    agency {
      id
      name
    }
    startDate {
      date
      dateStr
      dateFmt
    }
    endDate {
      date
      dateStr
      dateFmt
    }
    companyId
    inventoryName
    inventoryId
    inventoryReferenceId
    deviceId
    inventoryType
    inventoryAddress
    inventoryVenueType
    inventoryResolutions
    inventoryLocation
    duration
    inventoryReports {
      totalPotentialViews
      averageFrequency
      cpm
      totalReach
    }
    inventoryDetails {
      resolution1Width
      resolution1Height
      panel1Width
      panel1Height
      panel1Size
      videoSupport
      imageSupport
      panelFormat
    }
    inventoryThumbnailUrl
    inventoryLatitude
    inventoryLongitude
    inventoryPrice
    mediaOwnerName
    mediaOwnerId
  }
}
`;



export const GET_ASSIGNED_CONTENT = gql`
query AssignedContent(
  $accessToken: String!,
  $billboardId: String!,
  $campaignId: String!,
  $companyId: String!
) {
  assignedContent(
    accessToken: $accessToken,
    billboardId: $billboardId,
    campaignId: $campaignId,
    companyId: $companyId
  ) {
    id
    masterCreativeId
    status
    resolution
    fileName
    thumbnail
    comments
    duration
    mimeType
  }
}
`;

export const ASSIGNED_CONTENT_COUNT = gql`
  query AssignedContentCount(
    $accessToken: String!,
    $billboardIds: [String!]!,
    $companyId: String!,
    $campaignId: String!
  ) {
    assignedContentCount(
      accessToken: $accessToken,
      billboardIds: $billboardIds,
      companyId: $companyId,
      campaignId: $campaignId
    ) {
      count
      id
    }
  }
`;

export const GET_ASSIGN_ECOMMERCE_ASSETS = gql`
query EcommerceAssets(
  $accessToken: String!,
  $companyId: String!,
  $userId: String!,
  $page: Int!,
  $resolution: String,
  $size: Int!
) {
  ecommerceAssets(
    accessToken: $accessToken,
    companyId: $companyId,
    userId: $userId,
    page: $page,
    resolution: $resolution,
    size: $size
  ) {
    id
    creativeRefId
    masterCreativeId
    fileName
    mimeType
    fileSize
    duration
    filePath
    thumbnail
    thumbnailAvailable
    userId
    companyId
    countryId
    source
    status
    metadata {
      type
      dealId
      campaignId
      billboardId
      mediaOwnerId
      agencyId
      comments
      folder
      approvedBy
      rejectedBy
      maxStatus
      campaign
      buyerCreativeId
      brandId
      productId
      tagIds
    }
    resolution
    comments
    maxAssignedCreativeId
    proofOfPlayStatus
    rejectMessage
    title
    totalPages
    description
    creativeName
    creativeAdType
    callToActionUrl
    callToActionText
    createdBy
    createdDate
    lastModifiedBy
    lastModifiedDate
  }
}
`;

export const GENERATE_IMAGE_ASSET_QUERY = (billboards: any[]) => {
  const sort = "last_modified_date,desc";
  let _query = `query GetGalleryImageAssets {`
  let hasValidBillboards = false;

  billboards.forEach((billboard) => {
    // Skip if required fields are missing
    if (!billboard.id || !billboard.type) {
      return;
    }

    hasValidBillboards = true;
    _query += `
    _${billboard.id}: galleryImageAssets(
      sort: "${sort}"
      metadataBillboardId: "${billboard.id}"
      thumbnail: "${billboard.thumbnail || billboard.thumbnailPath || ""}"
      metadataType: "${billboard.type}"
    ) {
      filePath
      metaData {
        billboardId
      }
    }
    `;
  });

  // If no valid billboards, return a minimal query to avoid syntax errors
  if (!hasValidBillboards) {
    _query = `query GetGalleryImageAssets { __typename }`;
  } else {
    _query += `}`;
  }

  return gql`${_query}`;
}

export const GALLERY_IMAGE_ASSETS_QUERY = gql`
  query GetGalleryImageAssets(
    $sort: String!,
    $metadataBillboardId: String!,
    $metadataType: String!
  ) {
    galleryImageAssets(
      sort: $sort
      metadataBillboardId: $metadataBillboardId
      metadataType: $metadataType
    ) {
      id
      fileName
      mimeType
      fileSize
      duration
      filePath
      thumbnail
      thumbnailAvailable
      userId
      companyId
      countryId
      source
      status
      metaData {
        type
        billboardId
        mediaOwnerId
        tagged
        latitude
        longitude
        comments
        tags
        primary
        secondary
        source
        uploadedBy
        falcon
      }
      resolution
      comments
      maxAssignedCreativeId
      proofOfPlayStatus
      rejectMessage
      title
      description
      creativeName
      creativeAdType
      callToActionUrl
      callToActionText
      createdBy
      createdDate
      lastModifiedBy
      lastModifiedDate
    }
  }
`;

export const USER_ACCOUNT_QUERY = gql`
    query userAccount($accessToken: String!) {
    userAccount(accessToken: $accessToken) {
      id
      login
      password
      firstName
      lastName
      phone
      email
      activated
      langKey
      authorities
      accountType
      companyName
      companyId
      companyType
      country {
        id
        countryId
        name
        nameJa
        latitude
        longitude
        tax {
          label
          percent
        }
      }
      lastModifiedBy
      lastModifiedDate
      ecommerceDomainName
      userCompanyName
      userCompanyId
      userCompanyAddress
      userCompanyPhoneNumber
      platform
      userCountry
      userCity
      industry
      jobTitle
    }
  }
`;

// export const ASSIGNED_ASSETS_TOCAMPAIGN = gql`
//  mutation AssignAssetToCampaign(
//   $accessToken: String!,
//   $assetId: ID!,
//   $dealId: String!,
//   $campaignId: String!,
//   $billboardId: String!,
//   $inventoryType: String!,
//   $mediaOwnerId: String!,
//   $playInSequence: Boolean!,
//   $landingUrl: String,
//   $mobileInventory: Boolean!,
//   $skippable: Boolean!,
//   $schedule: [ScheduleInput!]!
// ) {
//   assignAssetToCampaign(
//     accessToken: $accessToken,
//     assetId: $assetId,
//     dealId: $dealId,
//     campaignId: $campaignId,
//     billboardId: $billboardId,
//     inventoryType: $inventoryType,
//     mediaOwnerId: $mediaOwnerId,
//     playInSequence: $playInSequence,
//     landingUrl: $landingUrl,
//     mobileInventory: $mobileInventory,
//     skippable: $skippable,
//     schedule: $schedule
//   ) {
//     message
//     statusCode
//     description
//   }
// }
// `;

// Proof Of Play

export const ASSIGNED_ASSETS_TOCAMPAIGN = gql`
  mutation AssignAssetsToCampaign($inputs: [AssignAssetToCampaignInput!]!) {
    assignAssetToCampaign(inputs: $inputs) {
      message
      statusCode
      description
    }
  }
`;

export const PROOF_OF_PLAY = gql`
  query ProofOfPlay(
  $accessToken: String!,
  $page: Int!,
  $campaignId: String!,
  $metadataType: String!,
  $metadataCampaignId: String!,
  $metadataMediaOwnerId: String!,
  $source: String!,
  $startDate: String!,
  $endDate: String!,
  $size: Int!,
  $sort: String!
) {
  proofOfPlay(
    accessToken: $accessToken,
    page: $page,
    campaignId: $campaignId,
    metadataType: $metadataType,
    metadataCampaignId: $metadataCampaignId,
    metadataMediaOwnerId: $metadataMediaOwnerId,
    source: $source,
    startDate: $startDate,
    endDate: $endDate,
    size: $size,
    sort: $sort
  ) {
    id
    name
    dealId
    dsp
    bookingSource
    startDate {
      date
    }
    endDate {
      date
    }
    campaignStatus
    packages
    campaignInventories {
      id
      dsp
      startDate
      endDate
      companyId
      inventoryName
      inventoryId
      inventoryReferenceId
      inventoryType
      inventoryAddress
      inventoryVenueType
      inventoryThumbnailUrl
      inventoryPrice
      inventoryReports {
        totalPotentialViews
        averageFrequency
        cpm
        totalReach
      }
      inventoryLatitude
      inventoryLongitude
      mediaOwnerName
      mediaOwnerId
      packageName
      packageId
    }
  }
}
 
`;



// Prrof Of Play Asserts

export const PROOF_OF_PLAY_ASSERTS = gql`
  query ProofOfPlayAssets(
    $accessToken: String!,
    $page: Int,
    $metadataType: String,
    $metadataCampaignId: String,
    $metadataMediaOwnerId: String,
    $source: String,
    $startDate: String,
    $endDate: String,
    $size: Int,
    $sort: String,
    $billboardId: String
  ) {
    proofOfPlayAssets(
      accessToken: $accessToken,
      page: $page,
      metadataType: $metadataType,
      metadataCampaignId: $metadataCampaignId,
      metadataMediaOwnerId: $metadataMediaOwnerId,
      source: $source,
      startDate: $startDate,
      endDate: $endDate,
      size: $size,
      sort: $sort,
      billboardId: $billboardId
    ) {
      id
      creativeRefId
      masterCreativeId
      fileName
      mimeType
      fileSize
      duration
      filePath
      thumbnail
      thumbnailAvailable
      userId
      companyId
      countryId
      source
      status
      createdDate
       metadata{
      billboardId
      billboardName
    }

    }
  }
`;


export const PROPERTY_DETAILS_CHART_QUERY = gql`
  query BubbleChart(
    $accessToken: String!,
    $countryId: String!,
    $id: String!,
    $rankLimit: String!,
    $companyId: String,
    $exposure: String,
  ) {
    bubbleChartData(
      accessToken: $accessToken,
      countryId: $countryId,
      id: $id,
      rankLimit: $rankLimit
      companyId: $companyId,
      exposure: $exposure

    ) {
      segments {
        name
        firstLevel {
          name
          value
          secondLevel
        }
      }
    }
  }
`;


export const NEGOTIATE_CAMPAIGN_SEND_REQUEST = gql`
mutation Negotiate($negotiationData: NegotiateInput!, $accessToken: String!, $campaignId: String!) {
    negotiate(
        negotiationData: $negotiationData,
        accessToken: $accessToken,
        campaignId: $campaignId
    ) {
        response {
            success
            statusCode
            message
            id
        }
    }
}

`


export const NEGOTIATE_CAMPAIGN_QUERY = gql`
  query negotiateCampaign($accessToken: String!, $campaignId: String!) {
    negotiateCampaign(accessToken: $accessToken, campaignId: $campaignId) {
      id
      dealId
      name
      bookingSource
      startDate {
        date
        dateStr
        dateFmt
      }
      endDate {
        date
        dateStr
        dateFmt
      }
      dsp
      campaignStatus
      priceSummary {
        subTotal
        netTotal
        currency {
          country
          symbol
          code
        }
        tax {
          name
          value
          percent
        }
        pcrEnable
      }
      inventoriesSummary {
        classicInventories
        digitalInventories
        packages
      }
      packages
      campaignInventories {
        id
        dsp
        startDate
        endDate
        inventoryName
        inventoryId
        inventoryThumbnailUrl
        inventoryType
        inventoryReports {
          totalPotentialViews
          averageFrequency
          cpm
          totalReach
        }
        discount
        negotiationSummary {
          buyerPreferredPrice {
            totalPrice
            savingsPrice
            savingsPerc
            nowPayPrice
            dailyPrice
            subTotal
          }
          mediaOwnerPreferredPrice {
            totalPrice
            savingsPrice
            savingsPerc
            nowPayPrice
            dailyPrice
            subTotal
          }
          contentManagementFeePerc
          platformFeePerc
          taxPerc
          discountPerc
          customFees
          summaryReport {
            potentialViews
            uniqueReach
            cpm
            totalSpots
          }
          status
          accountType
          requestFrom
        }
      }
      agency {
        id
        name
      }
      company {
        id
        name
      }
      user {
        id
        name
      }
      summaryReport {
        potentialViews
        uniqueReach
        cpm
        averageFrequency
        totalSpots
      }
      externalCampaignId
      madCampaignId
      reasonForRejection
      reporting {
        proofOfPlay
        deliveryReports
      }
      negotiationSummary {
        buyerPreferredPrice {
          totalPrice
          savingsPrice
          savingsPerc
          nowPayPrice
          dailyPrice
          subTotal
        }
        mediaOwnerPreferredPrice {
          totalPrice
          savingsPrice
          savingsPerc
          nowPayPrice
          dailyPrice
          subTotal
        }
        contentManagementFeePerc
        platformFeePerc
        taxPerc
        discountPerc
        customFees
        summaryReport {
          potentialViews
          uniqueReach
          cpm
          totalSpots
        }
        status
        accountType
        requestFrom
      }
    }
  }
`;

// Change Password

export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($accessToken: String!, $newPassword: String!, $userId: String!) {
    changePassword(
      accessToken: $accessToken,
      newPassword: $newPassword,
      userId: $userId
    ) {
      response {
        success
        message
      }
    }
  }
`;

export const UPDATE_PROFILE_MUTATION = gql`
mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    message
  }
}
`;



// Cart page Initaial Qurey

export const CART_INITIAL_QUERY = gql`
  query($accessToken: String!, $userId: String!) {
    cartpageItem(accessToken: $accessToken, userId: $userId) {
      id
      userId
      campaignName
      startDate
      endDate
      cartItemName
      cartItemId
      cartItemReferenceId
      cartItemDeviceId
      cartItemType
      cartItemCountry
      cartItemVenueType
      cartItemResolutions
      cartItemThumbnailUrl
      cartItemLatitude
      cartItemLongitude
      availableBooking
      nextAvailableDate
      spotsAvailability
      clientsAvailability
    }
  }
`;


// Payment Pending

export const CREATE_CHECKOUT_SESSION = gql`
  mutation CreateCheckoutSession(
    $basket: BasketInput!,
    $payPublicKey: String!,
    $paySecretKey: String!,
    $siteType: String!,
    $currentDomain: String!
    $successUrl: String!,
    $cancelUrl: String!
  ) {
    createCheckoutSession(
      basket: $basket,
      payPublicKey: $payPublicKey,
      paySecretKey: $paySecretKey,
      siteType: $siteType,
      currentDomain: $currentDomain,
      successUrl: $successUrl,
      cancelUrl: $cancelUrl
    ) {
      id
      url
      requiresAction
      clientSecret
      error
    }
  }
`;

// Payment Success
export const UPDATESTATUSMUTATION = gql`
  mutation UPDATESTATUSMUTATION(
    $accessToken: String!,
    $campaignId: String!,
    $reasonForRejection: String,
    $campaignStatus: String!
  ) {
    updateCampaignStatus(
      accessToken: $accessToken,
      campaignId: $campaignId,
      reasonForRejection: $reasonForRejection,
      campaignStatus: $campaignStatus
    ) {
      success
      message
    }
  }
`;

// Submit Enquiry

export const SUBMIT_ENQUIRY = gql`
mutation SubmitEnquiry(
  $name: String!,
  $companyName: String!,
  $email: String!,
  $phone: String!,
  $address: String!,
  $startDate: String!,
  $endDate: String!,
  $addedBillboardIds: [AddedBillboardInput!]!,
  $companyId: String!,
  $countryId: String!,
  $countryName: String!,
  $exposure: String!
) {
  submitEnquiry(
    name: $name,
    companyName: $companyName,
    email: $email,
    phone: $phone,
    address: $address,
    startDate: $startDate,
    endDate: $endDate,
    addedBillboardIds: $addedBillboardIds,
    companyId: $companyId,
    countryId: $countryId,
    countryName: $countryName,
    exposure: $exposure
  ) {
    message
  }
}
`;

export const CHATBOT_ANSWER = gql`
  query ChatbotAnswer($question: String!) {
    chatbotAnswer(question: $question) {
      question
      answer
    }
  }
`;

export const COUNTRY_CODE_LIST = gql`
  query CountryCodeList {
    countryCodeList {
      code
      country
      currency
      currencySymbol
      ISO
    }
  }
`;

export const GET_DAILY_DELIVERY_REPORT = gql`
  query DailyDeliveryReport(
    $accessToken: String!
    $dealId: String!
    $inventoryId: String!
    $startDate: String
    $endDate: String
    $month: String
    ) {
    campaignDeliveryReport(
      reportType: "daily"
      accessToken: $accessToken
      dealId: $dealId
      inventoryId: $inventoryId
      startDate: $startDate
      endDate: $endDate
      month: $month
    ) {
      reports {
        id
        adPlays
        creativeNames
        creativeTypes
        dealId
        playerName
        publisherName
        firstPlayDate
        lastPlayDate
        deliveryGoal
      }
    }
  }
`;

export const GET_DETAILED_DELIVERY_REPORT = gql`
  query DetailedDeliveryReport(
    $accessToken: String!
    $dealId: String!
    $inventoryId: String!
    $date: String!
    $page: Int
    $size: Int
    ) {
    campaignDeliveryReport(
      reportType: "detailed"
      accessToken: $accessToken
      dealId: $dealId
      inventoryId: $inventoryId
      date: $date
      page: $page
      size: $size
    ) {
      reports {
        id
        adPlays
        creativeNames
        creativeTypes
        creativeDuration
        dealId
        playerName
        publisherName
        firstPlayDate
        lastPlayDate
        deliveryGoal
        startTime
        endTime
        userAgent
        timezone
        country
        city
        ipAddress
      }
      totalPage  
    }
  }
`;


export const MEDIA_OWNER_FILTER = gql`
  query MediaOwnerFilter($accessToken: String!, $countryName: String!, $type: String!, $authentication: Boolean!) {
    mediaOwnerNameToken(accessToken: $accessToken, countryName: $countryName, type: $type, authentication: $authentication) {
      id
      name
    }
  }
`;

export const COMPANY_LIST = gql`
  query CompanyList(
    $exposure: String!
    $countryId: String!
    $page: Int!
    $size: Int!
  ) {
    companyList(
      exposure: $exposure
      countryIds: $countryId
      page: $page
      size: $size
    ) {
      id
      name
    }
  }
`;

export const ECOMMERCE_CONFIG = gql`
  query EcommerceConfig($accessToken: String!, $companyId: String!) {
    ecommerceConfig(accessToken: $accessToken, companyId: $companyId) {
      paymentIntegrationConfig {
        provider,
        accessKey
      }
    }
  }
`;

export const GET_STATE_LIST_MARKETPLACE = gql`
  query GetStateListMarketplace($countryIds: String!, $exposure: String!) {
    stateListMarketplace(countryIds: $countryIds, exposure: $exposure) {
      stateId
      name
    }
  }
`;

export const GET_DISTRICT_LIST_MARKETPLACE = gql`
  query GetDistrictListMarketplace($stateIds: String!, $exposure: String!) {
    districtListMarketplace(stateIds: $stateIds, exposure: $exposure) {
      id
      districtId
      name
      __typename
    }
  }
`;

export const OFFLINE_PAYMENT_UPLOAD_MUTATION = gql`
  mutation UploadOfflinePayment(
    $accessToken: String!
    $files: [Upload!]!
    $campaignId: String!
    $paymentType: String!
    $source: String!
  ) {
    uploadOfflinePayment(
      accessToken: $accessToken
      files: $files
      campaignId: $campaignId
      paymentType: $paymentType
      source: $source
    ) {
      success
      message
      paymentId
      paymentReferenceId
      paymentType
      paymentStatus
      status
      paymentProviderMedata {
        bankName
        accountName
        accountNumber
      }
      assets {
        id
        fileName
        filePath
        resolution
        duration
        metadata
      }
      campaign {
        id
        dealId
        name
        bookingSource
        campaignStatus
        startDate {
          date
          dateStr
          dateFmt
        }
        endDate {
          date
          dateStr
          dateFmt
        }
        dsp
        priceSummary {
          subTotal
          netTotal
          pcrEnable
          currency {
            country
            symbol
            code
          }
          tax {
            name
            value
            percent
          }
        }
        inventoriesSummary {
          classicInventories
          digitalInventories
          packages
        }
        campaignInventories {
          id
          dsp
          startDate
          endDate
          companyId
          inventoryName
          inventoryId
          inventoryReferenceId
          inventoryType
          inventoryVenueType
          inventoryThumbnailUrl
          inventoryPrice
          inventoryLatitude
          inventoryLongitude
          isSpotBased
          inventoryReports {
            totalPotentialViews
            averageFrequency
            cpm
            totalReach
          }
        }
        agency {
          id
          name
        }
        company {
          id
          name
        }
        user {
          id
          name
        }
        summaryReport {
          potentialViews
          uniqueReach
          cpm
          averageFrequency
          totalSpots
        }
        reporting {
          proofOfPlay
          deliveryReports
        }
        mediaOwners
        buyerDetails {
          name
          companyName
          email
          mobile
          address
        }
        createdDate
        lastModifiedDate
      }
    }
  }
`;

export const COMPANY_PAYMENT_OPTIONS = gql`
   query GetCompanyPaymentOptions($companyId: String!) {
    companyPaymentOptions(companyId: $companyId) {
      id
      paymentType
      active
      paymentMetadata {
        # GraphQL will only return the fields matching the specific type found
        
        ... on BankTransferMetadataType {
          bankName
          accountName
          accountNumber
          additionalDetails {
            swiftCode
            bankBranchCode
            bankCountry
            customFieldLabel
            customFieldValue
          }
        }

        ... on StripeMetadataType {
          stripeAccessKey
          stripeSecretKey
        }

        ... on BNPLMetadataType {
          providerName
          providerContactPerson
          providerContactNumber
          providerEmail
          termsUrl
        }
      }
    }
  }
`;

export const PAYMENT_TRANSACTION_DETAILS = gql`
query GetPaymentTransactionDetails($accessToken: String!, $campaignId: String!) {
  paymentTransactionDetails(
    accessToken: $accessToken
    campaignId: $campaignId
  ) {
    paymentId
    paymentReferenceId
    paymentType
    paymentStatus
    status
    failureReason
    paymentProviderMedata {
      accountName
      bankName
      accountNumber
    }
    campaign {
      id
      dealId
      name
      bookingSource
      startDate {
        date
        dateStr
        dateFmt
      }
      endDate {
        date
        dateStr
        dateFmt
      }
      dsp
      campaignStatus
      priceSummary {
        grossTotal
        subTotal
        netTotal
        currency {
          country
          symbol
          code
        }
        tax {
          name
          value
          percent
        }
        pcrEnable
        couponName
        discountPercent
        discountedPrice
      }
      inventoriesSummary {
        classicInventories
        digitalInventories
        packages
      }
      packages
      campaignInventories {
        id
        dsp
        startDate
        endDate
        companyId
        inventoryName
        inventoryId
        inventoryReferenceId
        description
        deviceId
        foreignBillboardId
        networkId
        inventoryType
        inventoryAddress
        inventoryVenueType
        inventoryResolutions
        inventoryThumbnailUrl
        packageDetails
        inventoryPrice
        inventoryReports {
          totalPotentialViews
          averageFrequency
          cpm
          totalReach
        }
        inventoryLatitude
        inventoryLongitude
        inventoryFormat
        nowPayPrice
        discount
        spotDuration
        negotiationSummary
        spotsPerDay
        mediaOwnerId
        mediaOwnerName
        isSpotBased
      }
      agency {
        id
        name
      }
      company {
        id
        name
      }
      user {
        id
        name
      }
      summaryReport {
        potentialViews
        uniqueReach
        cpm
        averageFrequency
        totalSpots
      }
      externalCampaignId
      madCampaignId
      reasonForRejection
      reporting {
        proofOfPlay
        deliveryReports
      }
      negotiationSummary
      mediaBookingOrdersInvoiceId
      mediaOwners
      notes
      buyerDetails {
        name
        companyName
        email
        mobile
        address
      }
      country
      currency
      paymentType
      platformSource
      createdDate
      lastModifiedDate
    }
    assets {
      id
      fileName
      duration
      filePath
      metadata
      resolution
      createdDate
      lastModifiedDate
    }
  }
}
`;

export const GET_OFFLINE_PAYMENT_INVOICE = gql`
  query GetOfflinePaymentInvoice(
    $accessToken: String!
    $campaignId: String!
  ) {
    offlinePaymentInvoice(
      accessToken: $accessToken
      campaignId: $campaignId
    ) {
      invoiceId
      referenceInvoiceNumber
      paymentType
      paymentTransaction {
        id
        publisherId
        campaignId
        campaignName
        dealId
        amount
        currency
        customerEmail
        paymentProvider
        paymentStatus
        status
        failureReason
        failureCode
        failureMessage
        transactionId
        receiptUrl
        webhookProcessed
        createdDate
        lastModifiedDate
        
        providerMetadata {
          accountName
          accountNumber
          bankName
        }
      }
      
      campaign {
        id
        dealId
        name
        bookingSource
        dsp
        campaignStatus
        createdDate
        lastModifiedDate
        mediaOwners
        
        startDate {
          date
          dateStr
          dateFmt
        }
        
        endDate {
          date
          dateStr
          dateFmt
        }
        
        priceSummary {
          subTotal
          netTotal
          pcrEnable
          
          currency {
            country
            symbol
            code
          }
          
          tax {
            name
            value
            percent
          }
        }
        
        inventoriesSummary {
          classicInventories
          digitalInventories
          packages
        }
        
        campaignInventories {
          id
          dsp
          startDate
          endDate
          companyId
          inventoryName
          inventoryId
          inventoryReferenceId
          inventoryType
          inventoryVenueType
          inventoryThumbnailUrl
          inventoryPrice
          inventoryLatitude
          inventoryLongitude
          isSpotBased
          
          inventoryReports {
            totalPotentialViews
            averageFrequency
            cpm
            totalReach
          }
        }
        
        agency {
          id
          name
        }
        
        company {
          id
          name
        }
        
        user {
          id
          name
        }
        
        summaryReport {
          potentialViews
          uniqueReach
          cpm
          averageFrequency
          totalSpots
        }
        
        reporting {
          proofOfPlay
          deliveryReports
        }
        
        buyerDetails {
          name
          companyName
          email
          mobile
          addreBillboardss
        }
      }
      
      assets {
        id
        fileName
        filePath
        duration
        resolution
        metadata
        createdDate
        lastModifiedDate
      }
    }
  }`;

// GraphQL Mutation for AI Campaign Assistant Chat
export const CHAT_CAMPAIGN_ASSISTANT = gql`
  mutation ChatCampaignAssistant($sessionId: String!, $message: String!) {
    chatCampaignAssistant(sessionId: $sessionId, message: $message) {
      aiMessage
      isComplete
      extractedDetails {
        place {
          district
          state
          country
        }
        budget
        purpose
        venueType
        startDate
        endDate
      }
      billboardPackage {
        message
        data {
          id
          displayName
          name
          type
          size
          cost
          currencyCode
          thumbnailPath
          formattedAddress
          spotsPerDay
        }
      }
    }
  }
`;

// Define the PROPERTY_DETAILS GraphQL query
export const Billboard_DETAILS = gql`
  query billboardDetails($id: String!, $billboardType: BillboardType!) {
    billboardDetails(id: $id, billboardType: $billboardType) {
      id
      referenceId
      name
      displayName
      company
      category
      subCategory
      type
      latitude
      longitude
      venueType
      availableBooking
      active
      totalVisitors
      perDayPrice
      specification {
        resolution1Width
        resolution1Height
      }
      price {
        screenOnTime
        screenOffTime
        displayOnTime
        displayOffTime
        spotDuration
        localCurrencies {
          id
          currencyId
          iso
          country
          currency
          code
          symbol
        }
      }
      sellingRate {
        dsp
        daily
        weekly
        monthly {
          month1
          month3
          month6
          month12
        }
      }
      thumbnailPath
    }
  }
`;